import React from 'react'

import { Alert, Box, Snackbar } from '@mui/material'

// saves that change what the public app shows only reach it once the API rebuilds the app's data in the background
export const APP_UPDATE_NOTICE = 'Changes appear in the app within a few minutes.'

type SnackbarContextType = {
  // detail is an optional second line under the message, e.g. APP_UPDATE_NOTICE
  show: (message: string, severity?: 'success' | 'info' | 'warning' | 'error', detail?: string) => void
}
export const SnackbarContext: SnackbarContextType = {
  show: () => {
    // if used outside of SnackbarProvider, this function will not have been replaced so throw error
    throw new Error('SnackbarContext must be used within a SnackbarProvider')
  },
}

type SnackbarProviderProps = { children: React.ReactNode }

export const SnackbarProvider = ({ children }: SnackbarProviderProps): JSX.Element => {
  const [isShowing, setIsShowing] = React.useState(false)
  const [snackbarMessage, setSnackbarMessage] = React.useState<string>('')
  const [snackbarDetail, setSnackbarDetail] = React.useState<string>()
  const [snackbarSeverity, setSnackbarSeverity] = React.useState<'success' | 'info' | 'warning' | 'error'>('success')

  const handleClose = () => {
    setIsShowing(false)
  }

  SnackbarContext.show = (message, severity, detail) => {
    setIsShowing(true)
    setSnackbarMessage(message || '')
    setSnackbarDetail(detail)
    setSnackbarSeverity(severity || 'success')
  }

  return (
    <>
      {children}
      <Snackbar
        open={isShowing}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        // leave a two-line message up a little longer so there's time to read it
        autoHideDuration={snackbarDetail ? 8000 : 6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          variant="filled"
          severity={snackbarSeverity}
          color={snackbarSeverity}
          sx={{
            width: '100%',
            background: (theme) => theme.palette[snackbarSeverity].main,
            color: (theme) => theme.palette[snackbarSeverity].contrastText,
          }}
        >
          {snackbarMessage}
          {snackbarDetail && <Box sx={{ mt: 0.5, fontWeight: 400 }}>{snackbarDetail}</Box>}
        </Alert>
      </Snackbar>
    </>
  )
}
